"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFileSchemaProperties = exports.ClientFileSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.ClientFileSchema = base_schema_1.BaseSchema.extend({
    fileName: zod_1.z.string(),
    size: zod_1.z.number(),
    contentType: zod_1.z.string(),
    url: zod_1.z.string(),
    extension: zod_1.z.string(),
    fullPath: zod_1.z.string(),
    bucket: zod_1.z.string(),
    itemId: zod_1.z.string(),
    status: zod_1.z.string(),
    formId: zod_1.z.string().optional(),
    coachUserId: zod_1.z.string(),
});
exports.ClientFileSchemaProperties = {
    collectionName: "files",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=client-file-schema.js.map